import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import {
  FaExclamationTriangle,
  FaBell,
  FaPhone,
  FaExclamationCircle,
  FaCheckCircle,
  FaTimesCircle
} from "react-icons/fa";

function HMIAlarmas() {
  const [alarmas, setAlarmas] = useState([]);
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  const obtenerEstadosAlarmas = useCallback(() => {
    axios.get(`${API_URL}/api/estado-actual-alarmas/`)
      .then(response => setAlarmas(response.data.alarmas))
      .catch(error => console.error("Error obteniendo estados:", error));
  }, [API_URL]);

  useEffect(() => {
    obtenerEstadosAlarmas();
    const interval = setInterval(obtenerEstadosAlarmas, 5000);
    return () => clearInterval(interval);
  }, [obtenerEstadosAlarmas]);

    // Determina si hay alarmas pendientes de procesar
  const hasPending = alarmas.some(a =>
    (a.estado === "ACTIVA" && !a.confirmada) ||
    a.mensaje === "REVISAR"
  );

  // Función general para procesar todas las alarmas pendientes
  const handleProcessAll = () => {
    alarmas
      .filter(a => a.estado === "ACTIVA" && !a.confirmada)
      .forEach(a => confirmarAlarma(a.id, a.nombre));
    alarmas
      .filter(a => a.mensaje === "REVISAR")
      .forEach(a => revisarFalsoPositivo(a.id));
  };

  const revisarFalsoPositivo = (idAlarma) => {
    axios.patch(`${API_URL}/api/estado-actual-alarmas/${idAlarma}/`, {
      confirmada: true,
      estado: "NO_ACTIVA"
    }, {
      headers: { "X-CSRFToken": Cookies.get("csrftoken"), "Content-Type": "application/json" },
      withCredentials: true
    })
    .then(() => {
      console.log(`✅ Alarma ${idAlarma} revisada correctamente.`);
      axios.post(`${API_URL}/api/mqtt/`, {
        topic: `ALARMAS/Altura/CONFIRMADA`,
        message: "REVISADA desde HMI"
      });
      obtenerEstadosAlarmas();
    })
    .catch(error => console.error("Error al revisar la alarma:", error));
  };

  const confirmarAlarma = (idAlarma, nombre) => {
    axios.patch(`${API_URL}/api/alarmas/${idAlarma}/`, { confirmada: true }, {
      headers: { "X-CSRFToken": Cookies.get("csrftoken"), "Content-Type": "application/json" },
      withCredentials: true
    })
    .then(() => {
      console.log(`✅ Alarma ${idAlarma} confirmada.`);
      axios.post(`${API_URL}/api/mqtt/`, {
        topic: `ALARMAS/Altura/CONFIRMADA`,
        message: "CONFIRMADA desde HMI"
      })
      .then(() => console.log(`✅ MQTT enviado para alarma ${nombre}`))
      .catch(err => console.error("Error MQTT:", err));
      obtenerEstadosAlarmas();
    })
    .catch(error => console.error("Error al confirmar la alarma:", error));
  };

  const obtenerIconoCheck = (activo, estadoAlarma) => {
    const esActivo = Boolean(activo);
    if (estadoAlarma === "ACTIVA") {
      return esActivo
        ? <FaCheckCircle className="check-icon" style={{ color: "green" }} />
        : <FaTimesCircle className="check-icon" style={{ color: "red" }} />;
    } else {
      return <FaTimesCircle className="check-icon" style={{ color: "gray" }} />;
    }
  };

  return (
    <div>
       {/* Encabezado con título y botón alineados */}
      <div className="header-actions">
        <h2>🖥️ HMI - Estado de Alarmas</h2>
        <button
          className="btn-general"
          onClick={handleProcessAll}
          disabled={!hasPending}
        >
          <FaBell /> Confirmar Alarmas
        </button>
      </div>

      <div className="contenedor">
        <div className="grid">
          {alarmas
            .slice()
            .sort((a, b) => a.id - b.id)
            .map((alarma) => {
              let icono = null;
              let color = "#28a745";

              if (alarma.estado === "ACTIVA") {
                if (alarma.confirmada) {
                  icono = <FaExclamationCircle />;
                  color = "red";
                } else if (alarma.notificada) {
                  icono = <FaPhone />;
                  color = "red";
                } else {
                  icono = <FaExclamationTriangle />;
                  color = "red";
                }
              } else if (alarma.mensaje === "REVISAR") {
                icono = <FaExclamationCircle />;
                color = "orange";
              }

              return (
                <div key={alarma.id} className="alarma-card" style={{ borderColor: color }}>
                  <h2 className="alarma-nombre">{alarma.descripcion}</h2>

                  <div className="alarma-icon" style={{ color }}>{icono}</div>
                  <p style={{ color }}>
                    {alarma.estado === "ACTIVA"
                      ? alarma.estado
                      : alarma.mensaje === "REVISAR"
                        ? 'REVISAR'
                        : 'NO ACTIVA'
                    }
                  </p>
                  {alarma.estado === "ACTIVA" && (
                        <p>Confirmada: {obtenerIconoCheck(alarma.confirmada, alarma.estado)}</p>
                  )}
                </div>
              );
            })}
        </div>
      </div>

      <style>
        {`
        .header-actions {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
          }
          .grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 20px;
            margin-top: 20px;
            margin-bottom: 20px;
          }
          .alarma-card {
            border: 3px solid;
            border-radius: 10px;
            padding: 20px;
            text-align: center;
            transition: transform 0.3s;
          }
          .alarma-card:hover {
            transform: scale(1.05);
          }
          .btn-general {
            color: white;
            background-color: #007bff;
            border: none;
            padding: 8px 12px;
            border-radius: 5px;
            cursor: pointer;
            margin-bottom: 20px;
            font-size: 14px;
          }
          .btn-general:disabled {
            background-color: #cccccc;
            cursor: not-allowed;
          }
          .btn-general:hover {
            background-color: #0056b3;
          }
          .alarma-icon {
            font-size: 40px;
            margin: 10px 0;
          }
          .check-icon {
            font-size: 20px;
          }
          .alarma-nombre {
            font-size: 18px;
            font-weight: bold;
          }
        `}
      </style>
    </div>
  );
}

export default HMIAlarmas;
